import React from 'react'
import './My_progress_lottie.css'
import Lottie from 'react-lottie';
import * as animationData from './Light mode.json';


const My_progress_lottie = () => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <section className='main'>
                <div className='My_progress_lottie_icon'>
                    <Lottie className="me-auto"
                        options={defaultOptions}

                    />
                </div>
            </section>
        </>
    )
}

export default My_progress_lottie